import { ReadonlyCollection } from "@ioip/core/lib";
import { IFieldSchema } from "./IFieldSchema";
import { ControlType } from "../../types";
import { Form } from "./Form";
import { IComboBoxOption } from "@fluentui/react";

export interface IFieldProps {
    schema: IFieldSchema;
    form: Form;
}

export class Field {

    private $props: IFieldProps;

    constructor(props: IFieldProps) {
        this.$props = props;
    }

    get id(): string {
        return this.$props.schema.id;
    }

    get parentId(): string {
        return this.$props.schema.parentId;
    }

    get order(): number {
        return this.$props.schema.order ?? 0;
    }

    get colSm(): number {
        return this.$props.schema.colSm ?? 0;
    }

    get colMd(): number {
        return this.$props.schema.colMd ?? 0;
    }

    get colLg(): number {
        return this.$props.schema.colLg ?? 0;
    }

    get colXl(): number {
        return this.$props.schema.colXl ?? 0;
    }

    get colXxl(): number {
        return this.$props.schema.colXxl ?? 0;
    }

    get colXxxl(): number {
        return this.$props.schema.colXxxl ?? 0;
    }

    get controlType(): ControlType {
        return this.$props.schema.controlType;
    }

    get name(): string {
        return this.$props.schema.name;
    }

    get title(): string {
        return this.$props.schema.title;
    }

    get label(): string {
        return this.$props.schema.label;
    }

    get required(): boolean {
        return this.$props.schema.required;
    }

    get readonly(): boolean {
        return this.$props.schema.readonly;
    }

    get disabled(): boolean {
        return this.$props.schema.disabled;
    }

    get form(): Form {
        return this.$props.form;
    }

    get children(): ReadonlyCollection<Field> {
        return this.$props.form.fields.where(x => x.parentId == this.id);
    }

    getSchema(): IFieldSchema {
        return this.$props.schema;
    }

    toComboBoxOption(): IComboBoxOption {
        return {
            key: this.id,
            text: this.title
        }
    }

}